export const TERMS_OF_USE = `Termos de Uso — All Delivery

Última atualização: 09 de Maio de 2026

Bem-vindo ao aplicativo All Delivery.
Ao utilizar nossa plataforma, você concorda com os presentes Termos de Uso.

1. Sobre o aplicativo

O All Delivery é uma plataforma que conecta usuários, estabelecimentos parceiros e entregadores para realização de pedidos online de produtos e serviços.

2. Cadastro do usuário

Para utilizar algumas funcionalidades, o usuário poderá realizar cadastro informando dados como:

Nome
Telefone
E-mail
Endereço
Localização

O usuário é responsável pela veracidade das informações fornecidas.

3. Uso da plataforma

Ao utilizar o aplicativo, o usuário concorda em:

Não utilizar o app para atividades ilegais;
Não tentar invadir ou comprometer o sistema;
Não praticar fraudes;
Respeitar entregadores, estabelecimentos e demais usuários.

O descumprimento poderá resultar em suspensão ou bloqueio da conta.

4. Pedidos e pagamentos

Os pagamentos poderão ser realizados por meios disponibilizados na plataforma.

O All Delivery atua como intermediador entre usuário, estabelecimento e entregador, podendo realizar divisão de valores de entrega e pedidos conforme regras da plataforma.

Cada estabelecimento é responsável:

pelos produtos vendidos;
pelos preços;
pela qualidade;
pelo tempo de preparo.

5. Entregas

Os prazos de entrega podem variar conforme:

distância;
clima;
trânsito;
disponibilidade de entregadores.

O All Delivery não garante prazo exato de entrega.

6. Cancelamentos

Pedidos poderão ser cancelados conforme análise da plataforma e do estabelecimento parceiro.

Pedidos já preparados ou enviados poderão não ser reembolsáveis.

7. Limitação de responsabilidade

O All Delivery não se responsabiliza:

por produtos fornecidos pelos estabelecimentos;
por atrasos causados por terceiros;
por indisponibilidade temporária do sistema;
por danos causados por mau uso da plataforma.

8. Privacidade

Os dados dos usuários são tratados conforme nossa Política de Privacidade.

9. Alterações

Os presentes Termos podem ser alterados a qualquer momento sem aviso prévio.

10. Contato

Para suporte ou dúvidas:

E-mail: edleyjoao@gmail.com

Telefone: (87) 99992-7809`;

export const PRIVACY_POLICY = `Política de Privacidade — All Delivery

Última atualização: 09 de Maio de 2026

A privacidade dos usuários do All Delivery é importante para nós.

Esta Política explica como coletamos, utilizamos e protegemos seus dados.

1. Dados coletados

Podemos coletar:

Nome
Número de telefone
E-mail
Endereço
Localização
Informações de pagamento
Dados do dispositivo

2. Como utilizamos os dados

Os dados são utilizados para:

processar pedidos;
realizar entregas;
melhorar a experiência do usuário;
fornecer suporte;
enviar notificações relacionadas ao aplicativo.

3. Compartilhamento de dados

Os dados poderão ser compartilhados com:

estabelecimentos parceiros;
entregadores;
plataformas de pagamento;
autoridades legais quando necessário.

4. Segurança

Adotamos medidas para proteger os dados dos usuários, porém nenhum sistema é totalmente seguro.

5. Localização

O aplicativo poderá utilizar a localização do dispositivo para:

calcular entregas;
encontrar estabelecimentos próximos;
melhorar a experiência do usuário.

6. Cookies e tecnologias

O aplicativo poderá utilizar tecnologias para salvar preferências e melhorar funcionalidades.

7. Direitos do usuário

O usuário poderá solicitar:

acesso aos dados;
correção;
exclusão da conta;
remoção de informações pessoais.

8. Exclusão de Dados

Os usuários podem solicitar a exclusão de suas contas e dados pessoais enviando um e-mail para edleyjoao@gmail.com com o assunto "Exclusão de Conta All Delivery".

No e-mail, informe o nome, e-mail ou telefone cadastrado no aplicativo para que possamos localizar a conta.

Seus dados serão removidos de nossos servidores em até 72 horas após a confirmação da solicitação, exceto quando houver obrigação legal de retenção.

9. Menores de idade

O aplicativo não é destinado a menores de 18 anos sem supervisão dos responsáveis.

10. Alterações desta política

Esta Política poderá ser alterada a qualquer momento.

11. Contato

E-mail: edleyjoao@gmail.com

Telefone: (87) 99992-7809`;
